const id = "1069363383121935";
const src = "https://connect.facebook.net/en_US/fbevents.js";

function fbqFn(...rest) {
  if (fbqFn.callMethod) {
    fbqFn.callMethod(...rest);
  } else {
    fbqFn.queue.push(rest);
  }
}

function init() {
  if (!window.fbq) {
    fbqFn.loaded = true;
    fbqFn.push = fbqFn;
    fbqFn.queue = [];
    fbqFn.version = "2.0";

    window.fbq = window._fbq = fbqFn;
  }
}

function preload() {
  const { fbq } = window;

  if (fbq) {
    fbq("init", id);
    fbq("track", "PageView");
  }
}

export default {
  init,
  preload,
  src
};



// WEBPACK FOOTER //
// ./components/remarketing/config/facebook-pixel.js